import { createEvent } from 'effector';

import { Site } from '@m/types/api';
import { Bounds, CenterCoordinate } from '@m/types/MapTypes';

export type CheckoutSession = {
  planIndex: number;
  site: Site;
};

export const setIsUpcomingSubExpanded = createEvent<boolean>();
export const setBounds = createEvent<Bounds>();
export const setCenterCoordinate = createEvent<CenterCoordinate>();

export const setIndividualSubscriptionInvitationId = createEvent<string | null>();

export const setCheckoutSession = createEvent<CheckoutSession | null>();
